import React from 'react';
import PropTypes from 'prop-types';

import BaseVisibilities from './style';

/**
 * SaleVisibilities
 * @component
 *
 */
function SaleVisibilities({ children, isSecond }) {
  return (
    <BaseVisibilities isSecond={isSecond}>
      {React.Children.map(children, (child, i) => (
        <div className={`visible_${i}`}>{child}</div>
      ))}
    </BaseVisibilities>
  );
}
SaleVisibilities.defaultProps = {};
SaleVisibilities.propTypes = {
  children: PropTypes.node.isRequired,
  isSecond: PropTypes.bool.isRequired
};

export default SaleVisibilities;
